/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_login_button_authenticating = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authenticating...`)
};

const zh_hans1_login_button_authenticating = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`认证中...`)
};

const zh_hant1_login_button_authenticating = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`驗證中…`)
};

const fr_login_button_authenticating = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authentification…`)
};

const de_login_button_authenticating = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authentifizierung…`)
};

const ja_login_button_authenticating = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`認証中…`)
};

const ko_login_button_authenticating = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인증 중...`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const login_button_authenticating = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.login_button_authenticating(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("login_button_authenticating", locale)
	if (locale === "en") return en_login_button_authenticating(inputs)
	if (locale === "zh-Hans") return zh_hans1_login_button_authenticating(inputs)
	if (locale === "zh-Hant") return zh_hant1_login_button_authenticating(inputs)
	if (locale === "fr") return fr_login_button_authenticating(inputs)
	if (locale === "de") return de_login_button_authenticating(inputs)
	if (locale === "ja") return ja_login_button_authenticating(inputs)
	return ko_login_button_authenticating(inputs)
};